import * as React from "react";
import { Button } from "antd";
import { ModalFooterProps } from "../types";
import styles from "../BrowserServiceModal.module.scss";

export const ModalFooter: React.FC<ModalFooterProps> = ({
  selectionType,
  selectedCount,
  isConfirmLoading,
  onCancel,
  onConfirm,
}) => {
  if (selectionType === "none") {
    return (
      <div className={styles.footer}>
        <div className={styles.footerSelection} />
        <div className={styles.footerActions}>
          <Button type="primary" onClick={onCancel}>
            Done
          </Button>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.footer}>
      <div className={styles.footerSelection}>
        {selectedCount > 0 ? `Selected: ${selectedCount} item(s)` : "No items selected"}
      </div>
      <div className={styles.footerActions}>
        <Button type="default" danger onClick={onCancel}>
          Cancel
        </Button>
        <Button
          type="primary"
          onClick={onConfirm}
          loading={isConfirmLoading}
          disabled={selectedCount < 1 || isConfirmLoading}
        >
          Confirm{selectionType === "multi" && selectedCount > 0 ? ` (${selectedCount})` : ""}
        </Button>
      </div>
    </div>
  );
};
